import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateBanner } from "./updateBanner.request";
import { UpdateBannerResponse } from "./updateBanner.types";

const useUpdateBanner = (
  options?: MutationOptions<UpdateBannerResponse, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateBanner,
    ...options
  });
};

export default useUpdateBanner;
